module.exports = __webpack_public_path__ + "static/media/ic_ticket_board_gray.9a2d93e6.svg";